import * as React from 'react';
import classnames from 'classnames';
import { format, isSameDay, isSameYear } from 'date-fns';
import { ChevronLeft, ChevronRight, ZoomIn, ZoomOut } from 'lucide-react';
import { t } from '~/i18n';
import styles from './Analytics.module.css';
import { ANALYTICS_PRESETS, AnalyticsWindow } from './analyticsWindow';

function rangeLabel(start: number, end: number) {
  if (isSameDay(start, end)) return `${format(start, 'HH:mm')} – ${format(end, 'HH:mm')}`;
  if (end - start <= 3 * 24 * 3600 * 1000) return `${format(start, 'dd/MM HH:mm')} – ${format(end, 'dd/MM HH:mm')}`;
  if (isSameYear(start, end)) return `${format(start, 'dd/MM')} – ${format(end, 'dd/MM')}`;
  return `${format(start, 'MM/yyyy')} – ${format(end, 'MM/yyyy')}`;
}

const AnalyticsRangeControls: React.FC<{ timeWindow: AnalyticsWindow }> = ({ timeWindow }) => {
  const { start, end } = timeWindow;

  return (
    <div className={styles.Controls}>
      <div className={styles.WindowNavigation}>
        <button
          className={styles.IconButton}
          title={t('locationTimeline.earlier')}
          disabled={!timeWindow.canShiftEarlier}
          onClick={() => timeWindow.shift(-1)}
        >
          <ChevronLeft size={20} />
        </button>
        <button
          className={styles.IconButton}
          title={t('locationTimeline.zoomOut')}
          disabled={!timeWindow.canZoomOut}
          onClick={timeWindow.zoomOut}
        >
          <ZoomOut size={20} />
        </button>
        <div className={styles.WindowLabel}>
          <span className={styles.WindowMain}>{rangeLabel(start, end)}</span>
          <span className={styles.WindowSub}>{format(end, 'dd/MM/yyyy')}</span>
        </div>
        <button
          className={styles.IconButton}
          title={t('locationTimeline.zoomIn')}
          disabled={!timeWindow.canZoomIn}
          onClick={timeWindow.zoomIn}
        >
          <ZoomIn size={20} />
        </button>
        <button
          className={styles.IconButton}
          title={t('locationTimeline.later')}
          disabled={!timeWindow.canShiftLater}
          onClick={() => timeWindow.shift(1)}
        >
          <ChevronRight size={20} />
        </button>
      </div>
      <div className={styles.Presets}>
        {ANALYTICS_PRESETS.map((preset) => (
          <button
            key={preset.label}
            className={classnames(styles.Preset, timeWindow.preset === preset.span && styles.Active)}
            onClick={() => timeWindow.setSpan(preset.span)}
          >
            {preset.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default AnalyticsRangeControls;
